import { ReactNode } from 'react'
import cn from 'classnames'
import CloseIcon from './close.svg'
import styles from './index.module.scss'

type Props = {
  children: ReactNode
  className?: string
  closeIconClassName?: string
  modalIsOpen: boolean
  setModalIsOpen: (isOpen: boolean) => void
}

export const Modal: React.FC<Props> = ({
  children,
  className,
  closeIconClassName,
  setModalIsOpen,
  modalIsOpen,
}) => {
  if (!modalIsOpen) {
    return <></>
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.overlay} onClick={() => setModalIsOpen(false)}></div>
      <div className={cn(styles.modal, className)}>
        <CloseIcon
          className={cn(styles.close, closeIconClassName)}
          onClick={() => setModalIsOpen(false)}
        />
        {children}
      </div>
    </div>
  )
}
